export default "__VITE_ASSET__DCVIv4j8__"